import React from 'react';
import { GlassCard } from '../canvas';
import { Button } from '../../sdk';

/**
 * Video export result modal with preview
 * @param {Object} props
 * @param {string} props.exportUrl - Object URL of exported video
 * @param {number} props.slideIndex - Slide index (0-based)
 * @param {number} props.duration - Video duration in seconds
 * @param {function} props.onClose - Callback to close modal
 */
export function VideoExportModal({ exportUrl, slideIndex, duration, bgRounded = true, onClose }) {
  if (!exportUrl) return null;

  // Format duration as MM:SS
  const formatDuration = (seconds) => {
    if (!seconds) return '';
    const mins = Math.floor(seconds / 60);
    const secs = Math.round(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center bg-black/60 p-6"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div className="w-full max-w-[820px] max-h-[85vh]" onClick={(e) => e.stopPropagation()}>
        <GlassCard className="p-5">
          <div className="flex items-center justify-between gap-3">
            <div>
              <div className="text-sm font-semibold text-white/90">
                Video Export Ready
              </div>
              <div className="mt-1 text-xs text-white/60">
                Optimized for Instagram carousel ({formatDuration(duration)}).
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Button href={exportUrl} title="Open in a new tab">
                Open
              </Button>
              <Button
                href={exportUrl}
                download={`magic-forest-slide-${slideIndex + 1}.mp4`}
                className="border-purple-400/30 bg-purple-500/15 hover:bg-purple-500/25 text-purple-200"
                title="Download video"
              >
                Download
              </Button>
              <Button onClick={onClose}>
                Close
              </Button>
            </div>
          </div>

          <div className="mt-4 grid place-items-center">
            {/* 
              Video is 1080×1350 with 72px circular corner radius.
              Proportional border-radius scales with display size:
              72/1080 ≈ 6.667% width, 72/1350 ≈ 5.333% height.
            */}
            <video
              src={exportUrl}
              controls
              autoPlay
              loop
              muted
              playsInline
              className="max-h-[55vh] w-auto border border-white/10 bg-black"
              style={bgRounded ? { borderRadius: '6.667% / 5.333%' } : undefined}
            />
          </div>

          <div className="mt-4 flex items-center justify-between text-xs">
            <div className="text-white/55">
              Filename:{' '}
              <span className="text-white/75">magic-forest-slide-{slideIndex + 1}.mp4</span>
            </div>
            <div className="text-purple-300/70">
              1080×1350 • H.264 • 3.5Mbps • {formatDuration(duration)}
            </div>
          </div>
        </GlassCard>
      </div>
    </div>
  );
}
